import KeyDecision from "../model/KeyDecision";

export default class KeyDecisionInteractionEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {KeyDecision} keyDecision 
     */
    constructor(type, keyDecision, delay = 0) {
        this.type = type;
        this.keyDecision = keyDecision;
        this.delay = delay;
    }
}

KeyDecisionInteractionEvent.NOTIFY_KEY_DECISION_AVAILABLE = "KeyDecisionInteractionEvent.NOTIFY_KEY_DECISION_AVAILABLE";
KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN = "KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN";
KeyDecisionInteractionEvent.REQUEST_KEY_DECISION = "KeyDecisionInteractionEvent.REQUEST_KEY_DECISION";
KeyDecisionInteractionEvent.CANCEL_KEY_DECISION = "KeyDecisionInteractionEvent.CANCEL_KEY_DECISION";